import { useMemo } from "react";

import { useAnswerContext } from "contexts/answerContext";
import { useCurrentTenant } from "contexts/currentTenant";
import { buildGeocoder } from "services/geocoding";

const useGeocoder = (field) => {
  const tenant = useCurrentTenant();
  const { record: project } = useAnswerContext();
  const geocoder = useMemo(
    () => buildGeocoder(tenant, field, project.id),
    [tenant, field, project.id],
  );
  return geocoder;
};

export default useGeocoder;
